import AttendanceVerificationManager from 'cle/attendance_verification_manager'
import { hideElement, showElement } from 'utils/toggle_element_visibility'
import AJAX from 'utils/ajax'

export default class LiveWebcastAttendanceVerification {
  constructor(config, modal, telemeter, onFatalError, errorReporter) {
    this.config = config
    this.modal = modal
    this.avm = new AttendanceVerificationManager(config, modal, this.log, onFatalError, errorReporter)
    this.checkpoints = this.avm.checkpoints
    this.isChimeEnabled = false
    this.hasCompletedAttendance = config.attendanceAlreadyCompleted
    this.telemeter = telemeter
    this.onFatalError = onFatalError
  }

  run(zoomClient) {
    const firstCheckpointPosition = this.checkpoints[0].position
    const firstCheckpointTimeout = (firstCheckpointPosition - ((new Date()).getTime() / 1000)) * 1000
    const secondCheckpointPosition = this.checkpoints[1].position
    const secondCheckpointTimeout = (secondCheckpointPosition - ((new Date()).getTime() / 1000)) * 1000
    const endOfVideoTimeout = ((this.config.endDate - this.config.toleranceSeconds) - ((new Date()).getTime() / 1000)) * 1000

    this.zoomClient = zoomClient

    if (!this.hasCompletedAttendance) {
      // If it wasn't checked yet and it hasn't passed yet
      if (this.checkpoints[0].checked_at === null && firstCheckpointTimeout > 0) {
        this.firstCheckpointTimeoutId = setTimeout(
          () => { this.displayCheckpointPrompt(firstCheckpointPosition) }, firstCheckpointTimeout
        )
      }

      // If it wasn't checked yet and it hasn't passed yet, and if the first checkpoint is either checked or still to come
      if (this.checkpoints[1].checked_at === null && (this.checkpoints[0].checked_at || firstCheckpointTimeout > 0)) {
        this.secondCheckpointTimeoutId = setTimeout(
          () => { this.displayCheckpointPrompt(secondCheckpointPosition) }, secondCheckpointTimeout
        )
      }

      // A few seconds before the end of the webcast we complete the attendance
      this.endOfVideoTimeoutId = setTimeout(
        () => { this.completeAttendance() }, endOfVideoTimeout
      )
    }
  }

  displayCheckpointPrompt(second) {
    if (this.meetingIsOpen()) {
      this.avm.displayCheckpointPrompt((node) => {
        const $el = document.getElementById("live-webcast-attendance-verification")
        $el.innerHTML = ""
        $el.appendChild(node)
        showElement($el)

        this.startPromptCountDown(node, second)
      })
    }
  }

  startPromptCountDown(node, second) {
    this.avm.startPromptCountDown(
      node,
      second,
      {
        onClose: (_) => {
          hideElement(document.getElementById("live-webcast-attendance-verification"))
        },
        displayExpiredPopup: (node) => {
          this.clearTimeouts() // We won't display checkpoints anymore
          const $el = document.getElementById("live-webcast-attendance-expired-checkpoint")
          $el.innerHTML = ""
          $el.appendChild(node)
          showElement($el)
        },
        clickExpiredPopup: (_) => {
          hideElement(document.getElementById("live-webcast-attendance-expired-checkpoint"))
        }
      }
    )
  }

  clearTimeouts() {
    clearTimeout(this.firstCheckpointTimeoutId)
    clearTimeout(this.secondCheckpointTimeoutId)
    clearTimeout(this.endOfVideoTimeoutId)
  }

  completeAttendance() {
    if (this.checkpointsCompleted() && this.meetingIsOpen()) {
      this.avm.completeAttendance(() => {
        this.log("Attendance completed on server. Enabling 'Claim certificate' button.")
        const $cleCourseCtaButtons = document.querySelectorAll("[data-js-cle-course-certificate-button]")

        AJAX.post(this.config.viewsUrl, { "viewed": true })

        $cleCourseCtaButtons.forEach((btn) => {
          btn.classList.remove("u-disable-pointer-events")
          btn.disabled = false
        })
      })
    }
  }

  meetingIsOpen() {
    return this.zoomClient.getCurrentMeetingInfo().isInMeeting
  }

  checkpointsCompleted() {
    return this.checkpoints.every((cp) => !!cp.checked_at)
  }

  log(message) {
    if(!this.telemeter) { return }
    // we don't want logging to ever _cause_ errors, so try/catch as a fail safe
    try {
      this.telemeter({
        message: message,
        videoTime: this.video.time()
      }, "info")
    } catch(e) {
      console.log(e)
    }
  }
}
